import {
  type AIAgent,
  type McpClientAgentData,
} from "@p0security/shared/types/ai-inventory";

/**
 * Converts the synthetic local-agents scope's collected MCP client record into
 * the inventory row shape.
 */
export const toLocalAgent = (
  data: McpClientAgentData,
  environment: { id: string; label?: string }
): AIAgent => ({
  platform: "local-agents",
  data,
  environmentId: environment.id,
  environmentLabel: environment.label ?? "Local agents",
});
